import { validate as uuidValidate } from 'uuid'

export function isUserAdminV2(user) {
  const preferredUsername = user.preferred_username

  const validePreferedUsername = uuidValidate(preferredUsername)

  if (validePreferedUsername) return true
  else return false
}

export function removeUnderscoreAndMakeItUpercase(ownerId) {
  if (!ownerId) return
  return ownerId
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ')
}
